type ApiErrorData<TError = unknown> = {
  code: number
  message: string
  data: TError
}

export class ApiError<TError = unknown> extends Error {
  code
  data

  constructor(errorData: ApiErrorData<TError>) {
    super(errorData.message)
    this.name = 'ApiError'
    this.code = errorData.code
    this.data = errorData.data
  }
}

export class AuthError extends ApiError {
  constructor(message: string) {
    super({ code: 401, message: message, data: null })
    this.name = 'AuthError'
  }
}

export class NotFoundError extends ApiError {
  constructor(message: string) {
    super({ code: 404, message: message, data: null })
    this.name = 'NotFoundError'
  }
}

export class NetworkError extends Error {
  constructor(message: string) {
    super(message)
    this.name = 'NetworkError'
  }
}
